/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsVaultConfigInput } from '../models/AwsVaultConfigInput';
import { AzureVaultConfigInput } from '../models/AzureVaultConfigInput';
import { GcpVaultConfigInput } from '../models/GcpVaultConfigInput';
import { Provider } from '../models/Provider';

/**
* Cloud-provider-specific vault attributes. 
*/
export class VaultProviderAttributesInput {
  'cloudProvider': Provider;
  'aws'?: AwsVaultConfigInput | null;
  'azure'?: AzureVaultConfigInput | null;
  'gcp'?: GcpVaultConfigInput | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "aws",
      "baseName": "aws",
      "type": "AwsVaultConfigInput",
      "format": ""
    },
    {
      "name": "azure",
      "baseName": "azure",
      "type": "AzureVaultConfigInput",
      "format": ""
    },
    {
      "name": "gcp",
      "baseName": "gcp",
      "type": "GcpVaultConfigInput",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return VaultProviderAttributesInput.attributeTypeMap;
  }

  public constructor() {
  }
}



